import Sidebar from "./ui/Sidebar";
import Navbar from "./ui/Navbar";
import { Route, Switch, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Admins from "./admins/Admins";
import AdminProfile from "./admins/AdminProfile";
import ConfirmPopup from './common/ConfirmPopup';

const AdminPortal = () => {
    let history = useHistory();

    useSelector(state => {
        let accessToken = state.auth.accessToken;
        if (accessToken === null) {
            history.push('/login');
            return;
        }
        let role = state.auth.role 
        if (role !== "Admin") {
            history.push('/admins');
            return;
        }
    });

    return (
        <div className="wrapper">
            <Sidebar />

            <div className="main">
                <Navbar />

                <div className="content">
                    <Switch>
                        <Route path="/admins/profile" component={AdminProfile} />
                        <Route path="/admins" component={Admins} />
                    </Switch>
                </div>


                <div className="footer">
                </div>

                <ConfirmPopup />
            </div>


        </div>
    );
};

export default AdminPortal;

